import { call, put, select, takeLatest } from "redux-saga/effects";
import iq_api_v2 from "../../../../services/iqApiV2";
import { FETCH_MEETING_PREPS_REQUEST, FetchMeetingPrepsFailure, FetchMeetingPrepsSuccess } from "../../actions/meetingPrep/meetingPrepsActions";
import qs from 'qs'

async function meetingPreps(clientName, accountName, userId) {
    const data = qs.stringify({
      client: clientName,
      account: accountName,
      user_id: userId,
    });

    try {
      // const response = await iq_api_v2.post('/meeting_prep', data, '');
      // const response = await iq_api_v2.post('/meeting_prep?'+data, {}, '');
      // const response = await iq_api_v2.post('/meeting_prep?', {}, {"params" : data} );
      
      // const queryString = qs.stringify(data);
      const response = await iq_api_v2.post("/meeting_prep/get_meeting_preps", data, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });
      
      
      

        return response?.data || [];
    } catch (error) {
        console.error('Error:', error.response ? error.response.data : error.message);
    }
  }

// Worker Saga
function* fetchMeetingPrepsSaga() {
  try {
    const payload = yield select(
      (state) => state?.meetingPrepsReducer?.payload
    );
    const {  clientName,accountName,userId,type } = payload;
    const data = yield call(
        meetingPreps,
        clientName,accountName,userId,type
    );
    yield put(FetchMeetingPrepsSuccess(data));
  } catch (error) {
    yield put(FetchMeetingPrepsFailure(error.message));
  }
}

// Watcher Saga
export function* watchMeetingPrepsSaga() {
  yield takeLatest(FETCH_MEETING_PREPS_REQUEST, fetchMeetingPrepsSaga);

}
